// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1PgHe","title":"AfterBackImages_title__1_pYE","images":"AfterBackImages_images__39yxg"};